export const learnMoreReauthUrl =
  'https://linearb.helpdocs.io/article/bpxcjbixu9-how-to-re-authorize-git-integration';

export const learnMorePlans = 'https://linearb.io/pricing/';
export const learnMoreSlackTroubleshooting =
  'https://linearb.helpdocs.io/article/gxnjb8qlsc-troubleshooting-slack-integration';

export const learnMoreWorkerBInlineApproval =
  'https://linearb.helpdocs.io/article/iplti0ts1j-worker-b-inline-approval';

export const configureScimWithOktaDocs =
  'https://linearb.helpdocs.io/article/ype1d6s18s-configuring-scim-with-okta';
